import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { usePlanningContext } from '../state/PlanningContext';

const notificationVariants = {
  hidden: { y: -100, opacity: 0 },
  visible: { 
    y: 0, 
    opacity: 1,
    transition: { 
      type: 'spring',
      damping: 25,
      stiffness: 300
    }
  },
  exit: { y: -100, opacity: 0 }
};

const animationProps = {
  initial: false,
  animate: 'visible',
  exit: 'exit'
};

const NotificationToast = () => {
  const { 
    themeMode, 
    showNotification, 
    notificationType, 
    notificationMessage 
  } = usePlanningContext();

  const getToastClasses = () => {
    let baseClasses = "fixed z-50 right-4 px-6 py-3 rounded-lg shadow-lg backdrop-blur-sm flex items-center gap-3 max-w-xs top-[calc(var(--navbar-height,64px)+1rem)]";
    
    switch (notificationType) {
      case "success":
        return `${baseClasses} bg-green-500/90 text-white`;
      case "error":
        return `${baseClasses} bg-red-500/90 text-white`;
      case "warning":
        return `${baseClasses} bg-yellow-500/90 text-white`;
      default:
        return themeMode === 'dark' 
          ? `${baseClasses} bg-gray-700/90 text-white` 
          : themeMode === 'light' 
            ? `${baseClasses} bg-white/90 text-gray-800 border border-gray-200` 
            : `${baseClasses} bg-white/90 text-gray-800 border border-amber-300`;
    }
  };
  
  const getIcon = () => {
    switch (notificationType) {
      case "success":
        return (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
          </svg>
        );
      case "error":
        return (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        );
      case "warning":
        return (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
        );
      default:
        return (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        );
    }
  };
  
  return (
    <AnimatePresence>
      {showNotification && (
        <motion.div
          className={getToastClasses()}
          variants={notificationVariants}
          {...animationProps}
        >
          {getIcon()}
          <span className="text-sm font-medium">{notificationMessage}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NotificationToast;
